import * as Diagram from "../../../../components/diagram";

export const AdultHealthCheckDetail = {
  label: "成人健檢明細",
  key: "AdultHealthCheckDetail",
  path: "HealthCenterHealthCheckup/AdultHealthCheckDetail",
  api: "TCS_V_HCCS04",
  render: (options) => (
    <Diagram.HealthCenterHealthCheckup.AdultHealthCheckDetail {...options} />
  ),
  isRaw: true,
  isPage: true,
  columns: [
    {
      key: "檢驗種類名稱",
      field: "檢驗種類名稱",
      header: "檢驗種類名稱",
    },
    {
      key: "類別",
      field: "類別",
      header: "類別",
    },
    {
      key: "創建時間",
      field: "創建時間",
      header: "創建時間",
    },
    {
      key: "項目名稱",
      field: "項目名稱",
      header: "項目名稱",
    },
    {
      key: "項目單位",
      field: "項目單位",
      header: "項目單位",
    },
    {
      key: "項目標準",
      field: "項目標準",
      header: "項目標準",
    },
    {
      key: "健檢結果",
      field: "健檢結果",
      header: "健檢結果",
    },
    {
      key: "是否異常",
      field: "是否異常",
      header: "是否異常",
    },
    {
      key: "姓名",
      field: "姓名",
      header: "姓名",
    },
    {
      key: "年齡層",
      field: "年齡層",
      header: "年齡層",
    },
    {
      key: "性別",
      field: "性別",
      header: "性別",
    },
    {
      key: "衛生所",
      field: "衛生所",
      header: "衛生所",
    },
    {
      key: "鄉鎮",
      field: "鄉鎮",
      header: "鄉鎮",
    },
    {
      key: "填表次序",
      field: "填表次序",
      header: "填表次序",
    },
  ],
};
